'use client'

import camelCase from 'lodash/camelCase'
import { useSearchParams } from 'next/navigation'

/**
 * 해당 hook은 queryParams를 핸들링 하는 hook이며 사용시에 항상 제네릭에 타입을 명시해줘야 함.
 */
export const useQueryParams = <T extends Record<string, any>>() => {
  const searchParams = useSearchParams()

  const queryParams = {} as { [K in keyof T]: string | null }
  searchParams.forEach((value, key) => {
    const newKey = camelCase(key)
    if (!queryParams[newKey]) {
      queryParams[newKey as keyof T] = value
    }
  })

  const getParam = <K extends keyof T>(key: K): string | null => queryParams[key] || null

  return { queryParams, getParam }
}
